import { HUB_HOST } from '@config';

export function getGoogleRedirectUri() {
  return `${HUB_HOST}/api/v1/oauth/callback/google`;
}
